import React, { useEffect, useState } from "react"

const LAPTOP_BREAKPOINT = 1024

const useSmallLaptop = () => {
  const [isSmallLaptop, setIsSmallLaptop] = useState(undefined)
  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${LAPTOP_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsSmallLaptop(window.innerWidth < LAPTOP_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsSmallLaptop(window.innerWidth < LAPTOP_BREAKPOINT)
    return () => mql.removeEventListener("change", onChange)
  }, [])
  return !!isSmallLaptop
}

export default useSmallLaptop
